export default "__VITE_ASSET__b0fa334c__"